import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoriesSection from './components/CategoriesSection';
import AboutSection from './components/AboutSection';
import ArticlesSection from './components/ArticlesSection';
import FAQSection from './components/FAQSection';
import CTABanner from './components/CTABanner';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://oopbuyspread.bond';

const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "OOPBuy Spreadsheet Deutschland",
  "url": siteUrl,
  "description": "Unabhängige Informationsplattform für OOPBuy Spreadsheet in Deutschland. Fashion Shopping Guide mit über 3.000 geprüften Produkten.",
  "inLanguage": "de",
};

const webSiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "OOPBuy Spreadsheet Deutschland",
  "url": siteUrl,
  "inLanguage": "de",
  "potentialAction": {
    "@type": "SearchAction",
    "target": `${siteUrl}/search?q={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
};

export default function Home() {
  return (
    <div className="min-h-screen">
      {/* Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webSiteSchema) }}
      />

      <Navbar />
      <main>
        <HeroSection />
        <CategoriesSection />
        <AboutSection />
        <ArticlesSection />
        <FAQSection />
        <CTABanner />
      </main>
      <Footer />
    </div>
  );
}